import { renderIsomorphicComponent, renderComponent, renderBreakingNews } from "@quintype/framework/client/start";
import get from "lodash/get";

import { pickComponent } from "../isomorphic/pick-component";
import { BreakingNewsView } from "../isomorphic/components/breaking-news-view";
import { MenuGroup } from "../isomorphic/components/layouts/footer/menu-group";
import { NavBar } from "../isomorphic/components/layouts/header/nav-bar";
import { TopAd } from "../isomorphic/components/ads/TopAd";
import { OutOfPageAd } from "../isomorphic/components/ads/OutOfPageAd";
import LoadingIndicatorComponent from "../isomorphic/components/atoms/loading-indicator";
import { BottomAd } from "../isomorphic/components/ads/BottomAd";
import { SearchToggle } from "../isomorphic/components/layouts/header/top-bar/searchToggle";
import { TopNav } from "../isomorphic/components/layouts/header/top-bar/topNav";
import { TopBarDate } from "../isomorphic/components/layouts/header/top-bar/topBarDate";
import { TopStickyAd } from "../isomorphic/components/ads/TopStickyAd";

export function preRenderApplication(store) {
  const hydrate = { hydrate: !global.qtLoadedFromShell };
  const breakingNewsConfig = get(store.getState(), ["qt", "config", "publisher-attributes", "breaking_news"], {});
  const breakingNewsInterval =
    breakingNewsConfig.interval && breakingNewsConfig.interval <= 60 ? 60 : breakingNewsConfig.interval;
  const breakingNewsbaseProps = {
    hydrate,
    updateInterval: breakingNewsInterval * 1000,
  };

  renderComponent(MenuGroup, "menu-group", store, hydrate);
  renderComponent(NavBar, "nav-bar", store, hydrate);
  breakingNewsConfig.is_enable &&
    renderBreakingNews("breaking-news-container", store, BreakingNewsView, breakingNewsbaseProps);
  renderComponent(LoadingIndicatorComponent, "loading-indicator", store);
  renderComponent(SearchToggle, "search-toggle", store);
  renderComponent(TopNav, "top-nav", store);
  renderComponent(TopBarDate, "top-bar-date", store);
}

// This is a separate file as everything from here on is hot reloaded when the app changes
export function renderApplication(store) {
  const enableAds = get(store.getState(), ["qt", "config", "ads-config", "dfp_ads", "enable_ads"]);

  enableAds && renderComponent(TopStickyAd, "top-sticky-ad", store);
  enableAds && renderComponent(TopAd, "top-ad", store);
  enableAds && renderComponent(OutOfPageAd, "out-of-page-ad-id", store);
  renderIsomorphicComponent("container", store, pickComponent, {
    hydrate: !global.qtLoadedFromShell,
  });
  enableAds && renderComponent(BottomAd, "bottom-ad", store);
}
